import {useTranslation} from "react-i18next";
import React from "react";
import {deepEqual} from "@tanstack/react-router";
import {Box, Button, LinearProgress, Stack} from "@mui/joy";

export interface TaskProgressProps {
    target?: string | React.JSX.Element;
    action: string;
    progress?: number;
    onCancel?: () => void;
}

// if progress is undefined, we are done
// if we are completely empty, that means we are blocked
// so there is no point in reporting our progress upstream
// call trigger() to start the task, and it is caller's
// responsibility to do this once and only once.
//
// DO NOT TRY THAT FROM AN EFFECT!!!
// MUCH PAIN WILL ENSUE IN STRICT MODE
//
// prefer instead to bubble up these ProgressingTasks, and then
// call trigger from an event handler.
// the existence of resolution is a valid test for whether
// trigger has been called.
// don't call trigger directly, use triggerTask so that magic
// works.

export interface ProgressingTask<T> {
    trigger?: () => Promise<T>;
    result?: T;
    progress?: TaskProgressProps;
    error?: Error;
}

export function dedupeProgressingTask<T>(prev: ProgressingTask<T>, next: ProgressingTask<T>):
    ProgressingTask<T> {
    if (prev.result) {
        return prev;
    }
    if (deepEqual(prev, next)) {
        return prev;
    }
    return next;
}

export function TaskProgressReport(
    {target, action, progress, onCancel}: TaskProgressProps) {
    const {t} = useTranslation();

    return <Stack spacing={2} direction="column"
                  sx={{width: "70%", mx: "auto", borderWidth: 4, borderColor: "primary"}}>
        <Box sx={{pl: 12, pt: 8, color: "text", fontSize: "medium"}}>
            {target && target} <span> - </span> {action}
        </Box>
        {progress === undefined ?
            <LinearProgress sx={{pl: 12, pt: 8}}/> :
            <LinearProgress sx={{pl: 12, pt: 8}} determinate value={progress}/>}
        {onCancel === undefined ? null :
            <Button sx={{px: 12, py: 6}} onClick={onCancel}>
                {t("cancel")}
            </Button>}
    </Stack>
}




